/**
 * ![teal 50](https://mui.com/static/colors-preview/teal-50-24x24.png) ![teal 100](https://mui.com/static/colors-preview/teal-100-24x24.png) ![teal 200](https://mui.com/static/colors-preview/teal-200-24x24.png) ![teal 300](https://mui.com/static/colors-preview/teal-300-24x24.png) ![teal 400](https://mui.com/static/colors-preview/teal-400-24x24.png) ![teal 500](https://mui.com/static/colors-preview/teal-500-24x24.png) ![teal 600](https://mui.com/static/colors-preview/teal-600-24x24.png) ![teal 700](https://mui.com/static/colors-preview/teal-700-24x24.png) ![teal 800](https://mui.com/static/colors-preview/teal-800-24x24.png) ![teal 900](https://mui.com/static/colors-preview/teal-900-24x24.png) ![teal A100](https://mui.com/static/colors-preview/teal-A100-24x24.png) ![teal A200](https://mui.com/static/colors-preview/teal-A200-24x24.png) ![teal A400](https://mui.com/static/colors-preview/teal-A400-24x24.png) ![teal A700](https://mui.com/static/colors-preview/teal-A700-24x24.png)
 */
const teal = {
  /**
   * Preview: ![teal 50](https://mui.com/static/colors-preview/teal-50-24x24.png)
   */
  50: '#e0f2f1',
  /**
   * Preview: ![teal 100](https://mui.com/static/colors-preview/teal-100-24x24.png)
   */
  100: '#b2dfdb',
  /**
   * Preview: ![teal 200](https://mui.com/static/colors-preview/teal-200-24x24.png)
   */
  200: '#80cbc4',
  /**
   * Preview: ![teal 300](https://mui.com/static/colors-preview/teal-300-24x24.png)
   */
  300: '#4db6ac',
  /**
   * Preview: ![teal 400](https://mui.com/static/colors-preview/teal-400-24x24.png)
   */
  400: '#26a69a',
  /**
   * Preview: ![teal 500](https://mui.com/static/colors-preview/teal-500-24x24.png)
   */
  500: '#009688',
  /**
   * Preview: ![teal 600](https://mui.com/static/colors-preview/teal-600-24x24.png)
   */
  600: '#00897b',
  /**
   * Preview: ![teal 700](https://mui.com/static/colors-preview/teal-700-24x24.png)
   */
  700: '#00796b',
  /**
   * Preview: ![teal 800](https://mui.com/static/colors-preview/teal-800-24x24.png)
   */
  800: '#00695c',
  /**
   * Preview: ![teal 900](https://mui.com/static/colors-preview/teal-900-24x24.png)
   */
  900: '#004d40',
  /**
   * Preview: ![teal A100](https://mui.com/static/colors-preview/teal-A100-24x24.png)
   */
  A100: '#a7ffeb',
  /**
   * Preview: ![teal A200](https://mui.com/static/colors-preview/teal-A200-24x24.png)
   */
  A200: '#64ffda',
  /**
   * Preview: ![teal A400](https://mui.com/static/colors-preview/teal-A400-24x24.png)
   */
  A400: '#1de9b6',
  /**
   * Preview: ![teal A700](https://mui.com/static/colors-preview/teal-A700-24x24.png)
   */
  A700: '#00bfa5',
} as const;

export default teal;
